import React from 'react'

export default function AdultServices(props) {
    return (
        <div>
            <p className="mainFont" style={{ fontSize: '1.25em' }}>
                Adult Services
                    </p>
            <p className="mainFont" style={{ fontSize: '1em' }}>
                Case Management and Outpatient Therapeutic Program Services
                    </p>
            <hr />
            <div style={{ marginLeft: '25px' }}>
                <p className="mainFont" style={{ fontSize: '1em' }}>
                    <b>Community Based Case Management (CBCM) Community Care Services (CCS)</b><br />
                                CBCM/CCS is for seriously mentally ill individuals who need recovery focused treatment
                                and supportive interventions in order to gain access to necessary services.  This program
                                is available 24 hours a day, every day. The goals of this program are for maximum reduction
                                of psychiatric symptoms and for optimal development of community living skills. CBCM/CCS is
                                often used as a “step down” program for individuals  discharged from community and state psychiatric
                                hospitals. It may also be used to serve persons at risk of psychiatric hospitalization.  These
                                services are offered on the islands of Oahu, Hawaii, Maui and Kauai.
                    <br /><br />
                    </p>
                    <span className="mainFont" style={{fontSize: '1em'}}>
                    Services include:
                    <ul>

                        <li>psychiatric care that prescribes and monitors medications for individuals to assist in the management
                    of mental health issues.</li>
                        <li>nursing care to insure that medication regimes are providing maximum support as well as to insure
                    that basic health needs are met.</li>
                        <li>case management to assist individuals finad and/or maintain stable housing in the community,
                        maximize entitlements for food and benefits, access needed services, and manage the challenges of
                    living in the community with a mental illness.</li>
                    </ul>
                    </span>
               
                <br />
                <p className="mainFont" style={{ fontSize: '1em' }}>
                    <b>Bio Psycho Social Rehabilitation (BPSR)</b><br />
                    The Bio Psycho-Social program provides a mixture of classes, practical experience, and community interaction as
                    individuals pursue the goal of recovery. Individuals are taught to manage the symptoms of mental illness so that
                    they may fully participate in community life. Practical experience includes learning how to shop for and prepare for
                    meals, scheduling medical appointments, developing leisure activities, and beginning to develop job-finding skills.
                    <br /><br />
                    Throughout the program, the goal of recovery is emphasized. Participants are encouraged and supported to
                    actively direct their recovery process through choosing activities that support their growth and development.
                    </p>
                <br />
                <p className="mainFont" style={{ fontSize: '1em' }}>
                    <b>Day Treatment</b><br />
                    The Day Treatment program focuses on treatment, relapse prevention, and recovery for individuals with serious
                    mental illness and addiction concerns. . Day Treatment provides the consumer with the opportunity to participate
                    in a structured therapeutic program while being able to reside in the community. Activities include, but are not
                    limited to, group counseling, education, skill building, recreational therapy, and family services.
                    </p>
                <br />
                <p className="mainFont" style={{ fontSize: '1em' }}>
                    <b>Partial Hospitalization Program (PHP)</b><br />
                    The Partial Hospitalization Program (PHP) is a medically supervised program that offers comprehensive, therapeutically 
                    intensive, coordinated, and structured clinical services. PHP consists of a series of face-to-face therapeutic sessions 
                    organized at various levels of intensity and frequency. PHP is designed for persons who are experiencing increased 
                    symptomatology, disturbances in behavior, or other conditions that negatively impact the mental or behavioral health of 
                    the person served. PHP focuses on coping skills, crisis stabilization, symptom/medication management, and skill building 
                    to help the consumer maintain themselves in the community. PHP can offer extra support for consumers at risk of hospitalization 
                    or have frequent hospitalizations.
                    </p>
                <br />
                <p className="mainFont" style={{ fontSize: '1em' }}>
                    <b>AfterCare</b><br />
                    This program provides graduates of the Day Treatment Program group and/or individual therapy and psycho-
                    educational activities focused on maintaining and strengthening the person’s recovery and relapse prevention
                    skills.
                    </p>
                <br />
                <p className="mainFont" style={{ fontSize: '1em' }}>
                    <b>Seeking Safety</b><br />
                    Seeking Safety is a present-focused therapy designed for people with serious mental illness and who have
                    experienced severe trauma in their lives. “Trauma” means that a person has suffered or witnessed a severe life
                    event, such as physical or sexual abuse, a car accident, or a hurricane. Many individuals with serious mental
                    illness an have experienced a trauma during their lifetime. Some people develop post traumatic stress disorder
                    (PTSD) as a result of their trauma and may also have developed addiction issues. You will learn more about this
                    during treatment.
                    The treatment consists of 25 psychotherapy topics. It is an “integrated” treatment, meaning that both trauma and
                    substance abuse issues are worked on at the same time to promote the most successful recovery possible.
                    Our Seeking Safety group for adults with severe and persistent mental illness are for those struggling with trauma
                    and/or Post traumatic Stress Disorder (PTSD) issues. The group focuses on teaching and processing safe coping
                    skills that restore ideals such as the following:
                    <br />
                </p>
                <span className="mainFont" style={{fontSize: '1em'}}>
                <ul>
                        <li>Respect</li>
                        <li>Care</li>
                        <li>Protection</li>
                        <li>Healing</li>
                        <li>Coping</li>
                        <li>Trust</li>
                    </ul>
                </span>
                <br />

            </div>
        </div>
    )
}
